import { Account, InputTypes, PaymentFormField } from '@cashier/cashier-model';

import { ConfigurationEnricher } from './model';

const ACCOUNT_ID_INPUT_NAME = 'accountId';

const buildAccountInput = (
  existingInput: PaymentFormField | undefined,
  currentAccount: Account | null,
  options: Account[],
): PaymentFormField => ({
  ...(existingInput || {
    name: ACCOUNT_ID_INPUT_NAME,
    type: InputTypes.AccountId,
    label: 'Account',
  }),
  required: !!currentAccount,
  value: currentAccount ? currentAccount.value : null,
  params: {
    options,
    isUiOnly: !currentAccount,
  },
});

export const AccountFieldEnricher: ConfigurationEnricher = {
  shouldEnrich: (_, { currentAccount, accountOptions }) =>
    Boolean(currentAccount || accountOptions.length),
  enrich: (configuration, { currentAccount, accountOptions }): void => {
    configuration.set(
      ACCOUNT_ID_INPUT_NAME,
      buildAccountInput(
        configuration.get(ACCOUNT_ID_INPUT_NAME),
        currentAccount,
        accountOptions,
      ),
    );
  },
};
